import { render } from "./TariffList.vue?vue&type=template&id=31d2ec6f&scoped=true"
import script from "./TariffList.vue?vue&type=script&lang=js"
export * from "./TariffList.vue?vue&type=script&lang=js"

import "./TariffList.vue?vue&type=style&index=0&id=31d2ec6f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d2ec6f"]])

export default __exports__